import request from '../index.js'

export const logApi = {
  // 获取操作日志列表
  getOperationLogs: (params) => request({ url: '/admin/operation-logs', method: 'get', params }),
  
  // 获取操作日志详情
  getOperationLogDetail: (id) => request({ url: `/admin/operation-logs/${id}`, method: 'get' }),
  
  // 获取操作日志统计
  getOperationLogStatistics: () => request({ url: '/admin/operation-logs/statistics', method: 'get' })
}
